module.exports = "/dist/b125be9d4669b48ecb697ec90cc999c3.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900.eot
// module id = 22
// module chunks = 0